import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  FontSize,
  FontWeight,
  Icon,
  IconVariant,
  ResponsiveValue,
  SpaceScale,
  Text,
} from '@gousto-internal/citrus-react'

type RecipeCountBadgeProps = {
  count: number
  iconSize: ResponsiveValue<SpaceScale>
  paddingH: ResponsiveValue<SpaceScale>
  textSize: ResponsiveValue<FontSize>
}

export const RecipeCountBadge = ({
  count,
  iconSize,
  paddingH,
  textSize,
}: RecipeCountBadgeProps) => (
  <Box display={Display.Flex} alignItems={AlignItems.Center}>
    <Box bg={Color.ColdGrey_50} paddingV={0.5} paddingH={paddingH} style={{ borderRadius: '4px' }}>
      <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={textSize}>
        {count}
      </Text>
    </Box>
    <Icon name="chevron_right" size={iconSize} variant={IconVariant.Actionable} />
  </Box>
)
